import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { PropTypes } from 'prop-types';
import Field from '../../constants/editable-field-tags';

const styles = {
  message: {
    maxWidth: '100%',
    textAlign: 'center',
    padding: 'xlarge'
  }
};
export default function Placeholder({ message }) {
  return (
    <UX2.Element.Text.Major style={ styles.message } featured data-route={ Field.RSS_FIELD_URL }>
      { message }
    </UX2.Element.Text.Major>
  );
}
Placeholder.propTypes = {
  message: PropTypes.string
};
